import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';

import { IPromotionWinnerRow } from 'core';

export interface IPromotionDetailWinnersModalData {
  promotionName: string;
  winners: IPromotionWinnerRow[];
}

@Component({
  selector: 'app-promotion-detail-winners-modal',
  imports: [TranslatePipe],
  templateUrl: './promotion-detail-winners-modal.component.html',
  styleUrl: './promotion-detail-winners-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PromotionDetailWinnersModalComponent {
  readonly #modal = inject(NzModalRef);
  readonly modalData = inject<IPromotionDetailWinnersModalData>(NZ_MODAL_DATA);
  readonly pageSize = 5;
  readonly currentPage = signal<number>(1);
  readonly totalPages = computed(() => Math.max(1, Math.ceil(this.modalData.winners.length / this.pageSize)));
  readonly pageNumbers = computed(() => Array.from({ length: this.totalPages() }, (_, index) => index + 1));

  readonly winnerRows = computed(() => {
    const offset = (this.currentPage() - 1) * this.pageSize;

    return this.modalData.winners.slice(offset, offset + this.pageSize);
  });

  public close(): void {
    this.#modal.destroy();
  }

  public onPageChange(page: number): void {
    if (page < 1 || page > this.totalPages() || page === this.currentPage()) {
      return;
    }

    this.currentPage.set(page);
  }
}
